import { Component, inject, OnInit, QueryList, signal, ViewChild, ViewChildren } from '@angular/core';
import { Router } from '@angular/router';
import { ConfigService } from 'src/app/services/config.service';
import { SearchModel } from 'src/app/models/search-model';
import { ActiveRecord } from 'src/app/state/active-records/models/active-records.response';
import { SwiperOptions } from 'swiper/types/swiper-options';
import { SwiperComponent } from '../../_shared/components/swiper/swiper.component';
import { ActiveRecordsFacade } from 'src/app/state/active-records/active-records.facade';
import { toSignal } from '@angular/core/rxjs-interop';
import { CardItemComponent } from 'src/app/_shared/components/card-item/card-item.component';
import { CheckoutItemButtonConfiguration } from 'src/app/models/buttons-config';

@Component({
  selector: 'active-records-swiper',
  templateUrl: './active-records-swiper.component.html',
  styleUrls: ['./active-records-swiper.component.scss'],
})
export class ActiveRecordsSwiperComponent implements OnInit {
  private readonly router = inject(Router);
  private readonly configService = inject(ConfigService);
  private readonly activeRecordsFacade = inject(ActiveRecordsFacade);

  readonly buttonConfig = new CheckoutItemButtonConfiguration(this.configService.get().showReturnLoanButton);
  readonly swiperConfig: SwiperOptions = {
    freeMode: true,
    watchOverflow: true,
    spaceBetween: 16,
    breakpoints: {
      0: { slidesPerView: 1.08, slidesPerGroup: 1 },
      768: { slidesPerView: 1.4, slidesPerGroup: 1 },
      992: { slidesPerView: 1.8, slidesPerGroup: 1 },
      1200: { slidesPerView: 2.15, slidesPerGroup: 2 },
      1600: { slidesPerView: 3.15, slidesPerGroup: 3 },
      1800: { slidesPerView: 3.15, slidesPerGroup: 3 },
    },
    slidesOffsetAfter: 8, //selectedOffset,
    slidesOffsetBefore: 8, //selectedOffset,
    navigation: {
      enabled: !this.configService.notDesktopDevice(),
    },
  };

  readonly activeRecords = toSignal(this.activeRecordsFacade.activeRecords$);
  readonly canMakeCheckouts = toSignal(this.activeRecordsFacade.canMakeCheckouts$);
  readonly isLoading = toSignal(this.activeRecordsFacade.isLoading$);

  @ViewChild(SwiperComponent) swiper: SwiperComponent;
  @ViewChildren(CardItemComponent) cards: QueryList<CardItemComponent>;

  readonly trackByRecordId = (_: number, activeRecord: ActiveRecord) => activeRecord.recordId;

  ngOnInit(): void {
    this.activeRecordsFacade.getActiveRecords();
  }

  ngAfterViewInit() {
    this.cards.changes.subscribe((queryList) => {
      if (queryList.length === this.activeRecords.length) {
        this.swiper.swiperContainer.nativeElement.swiper.updateSlides();
      }
    });
  }

  exploreFullCatalog() {
    const model = new SearchModel(undefined, this.configService.get().resultsFilterOrder);
    model.explore = true;
    this.router.navigate(['/results'], {
      queryParams: model.toRequest(),
    });
  }
}
